import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls the window to the top every time the route (pathname) changes.
// Place this once inside <BrowserRouter>, above <Routes>.
// It renders nothing — it only listens for navigation and scrolls.

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
